import { X } from "lucide-react-native";
import { Box } from "../../ui/box";
import { Button, ButtonIcon } from "../../ui/button";
import { HStack } from "../../ui/hstack";
import { Text } from "../../ui/text";

type Props = {
  message: string;
  onDismiss: () => void;
};

/**
 * A turn that failed.
 *
 * Deliberately NOT tied to the same "has the answer landed" predicate that retires
 * the streaming bubble: a failed run still writes the user's own message row, and
 * that row carries the same run id — so keying this off the run would make the
 * error vanish the instant that row arrived. A failure is dismissed by the user, or
 * replaced by the next send.
 */
const ErrorBubble = ({ message, onDismiss }: Props) => (
  <Box className="mb-3 max-w-[85%] self-start rounded-2xl border border-error-300 bg-error-50 px-4 py-3">
    <HStack space="sm" className="items-start justify-between">
      <Text className="flex-1 text-sm text-error-700">{message}</Text>
      <Button variant="link" size="sm" onPress={onDismiss}>
        <ButtonIcon as={X} className="text-error-700" />
      </Button>
    </HStack>
  </Box>
);

export default ErrorBubble;
